module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_9510_white.01802459.jpg";